export function stripHtml(value = "") {
  return String(value)
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function truncateText(value = "", max = 180) {
  const clean = stripHtml(value);

  if (clean.length <= max) return clean;

  return `${clean.slice(0, max - 1)}…`;
}

export function formatDateTime(value) {
  if (!value) return "Date inconnue";

  const raw = String(value).trim();

  const match = raw.match(
    /^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2}))?/,
  );

  if (!match) return "Date inconnue";

  const [, yyyy, mm, dd, hh, mi] = match;

  if (!hh || !mi) {
    return `${dd}/${mm}/${yyyy}`;
  }

  return `${dd}/${mm}/${yyyy} à ${hh}:${mi}`;
}

export function buildAssociationsSearchParams({
  q,
  categorie,
  stateFilter,
  hasLogo,
  withGps,
  page,
  limit,
}) {
  return {
    q: q?.trim() || undefined,
    categorie: categorie?.trim() || undefined,
    is_active:
      stateFilter === "all"
        ? undefined
        : stateFilter === "active"
          ? true
          : false,
    has_logo: hasLogo === "all" ? undefined : hasLogo === "yes",
    with_gps: withGps === "yes" ? true : undefined,
    page,
    limit,
    sort: "nom",
    dir: "ASC",
  };
}

export function normalizeAssociationForm(form) {
  return {
    nom_asso: form.nom_asso.trim(),
    categorie: form.categorie?.trim() || "",
    description_asso: form.description_asso || "",
    contact_asso: form.contact_asso?.trim() || "",
    fonction_asso: form.fonction_asso?.trim() || "",
    tel_asso: form.tel_asso?.trim() || "",
    mail_asso: form.mail_asso?.trim() || "",
    website_asso: form.website_asso?.trim() || "",
    facebook_asso: form.facebook_asso?.trim() || "",
    logo_asso: form.logo_asso?.trim() || "",
    adresse_asso: form.adresse_asso?.trim() || "",
    gps_asso: form.gps_asso?.trim() || "",
    is_active: !!form.is_active,
  };
}

export function validateAssociationForm(form) {
  const errors = {};

  if (!form.nom_asso?.trim()) {
    errors.nom_asso = "Le nom de l’association est obligatoire.";
  }

  return errors;
}

export function normalizeExternalUrl(url = "") {
  const clean = String(url || "").trim();

  if (!clean) return "";

  if (
    clean.startsWith("http://") ||
    clean.startsWith("https://") ||
    clean.startsWith("mailto:") ||
    clean.startsWith("tel:")
  ) {
    return clean;
  }

  if (clean.startsWith("/")) return clean;

  return `https://${clean}`;
}

export function getGoogleMapsUrl(gps = "") {
  const clean = String(gps || "").trim();

  if (!clean) return "";

  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    clean,
  )}`;
}

export function getAssociationsStats(items = [], total = 0) {
  const activeOnPage = items.filter((item) => !!item.is_active).length;
  const inactiveOnPage = items.filter((item) => !item.is_active).length;
  const withLogoOnPage = items.filter((item) => !!item.logo_asso).length;
  const withGpsOnPage = items.filter((item) => !!item.gps_asso).length;
  const withContactOnPage = items.filter(
    (item) => !!item.mail_asso || !!item.tel_asso || !!item.contact_asso,
  ).length;

  return {
    total,
    activeOnPage,
    inactiveOnPage,
    withLogoOnPage,
    withGpsOnPage,
    withContactOnPage,
  };
}